var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_4781851_calendar_date_day_event_month_icon",
    "data-name": "4781851_calendar_date_day_event_month_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(2.344 2.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15891",
    "data-name": "Path 15891",
    d: "M18.6,22.75H6.714A3.706,3.706,0,0,1,3,19.052V8.7A3.706,3.706,0,0,1,6.714,5H18.6a3.706,3.706,0,0,1,3.714,3.7V19.052A3.706,3.706,0,0,1,18.6,22.75ZM6.714,6.479A2.224,2.224,0,0,0,4.486,8.7V19.052a2.224,2.224,0,0,0,2.228,2.219H18.6a2.224,2.224,0,0,0,2.228-2.219V8.7A2.224,2.224,0,0,0,18.6,6.479Z",
    transform: "translate(-3 -3.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15892",
    "data-name": "Path 15892",
    d: "M22.906,23.688H19.781A.781.781,0,0,1,19,22.906V19.781A.781.781,0,0,1,19.781,19h3.125a.781.781,0,0,1,.781.781v3.125A.781.781,0,0,1,22.906,23.688Zm-2.344-1.562h1.563V20.563H20.563Z",
    transform: "translate(-7.3 -7.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15893",
    "data-name": "Path 15893",
    d: "M21.57,12.563H3.743a.782.782,0,0,1,0-1.562H21.57a.782.782,0,0,1,0,1.563Z",
    transform: "translate(-3 -5.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15894",
    "data-name": "Path 15894",
    d: "M10.781,7.688A.781.781,0,0,1,10,6.906V3.781a.781.781,0,0,1,1.563,0V6.906A.781.781,0,0,1,10.781,7.688Z",
    transform: "translate(-4.823 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15895",
    "data-name": "Path 15895",
    d: "M20.781,7.688A.781.781,0,0,1,20,6.906V3.781a.781.781,0,0,1,1.563,0V6.906A.781.781,0,0,1,20.781,7.688Z",
    transform: "translate(-7.427 -3)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2024",
    "data-name": "Rectangle 2024",
    width: 24,
    height: 24,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.540126df19ef718bf06d00bbbbc92698.svg";
export { ForwardRef as ReactComponent };